 <form class="custom-form" [formGroup]='authForm'>
     <div class="row" *ngIf="isNameShow">
        <div class="col-md-6">
            <div class="form-group custom-form-group">
                <input type="text"
                    class="form-control"
                    placeholder="First Name"
                    [class.ipm-error-border]="authForm.controls['firstName'].invalid && authForm.controls['firstName'].touched"
                    autocomplete="off"

                    name="firstName"
                    formControlName="firstName"
                    required>
                    <div class="ipm-error-icon" *ngIf="authForm.controls['firstName'].invalid && authForm.controls['firstName'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                <div class="help-block error-message"
                    *ngIf="authForm.controls['firstName'].invalid && authForm.controls['firstName'].touched">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {{formService.getErrorMessage(authForm.controls['firstName'])}}
                </div>
          </div>
        </div>
        <div class="col-md-6">
            <div class="form-group custom-form-group">
                <input type="text"
                    class="form-control"
                    placeholder="Last Name"

                    [class.ipm-error-border]="authForm.controls['lastName'].invalid && authForm.controls['lastName'].touched"
                    name="lname"
                    formControlName="lastName"
                    autocomplete="off"
                    required>
                    <div class="ipm-error-icon" *ngIf="authForm.controls['lastName'].invalid && authForm.controls['lastName'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                <div class="help-block error-message"
                    *ngIf="authForm.controls['lastName'].invalid && authForm.controls['lastName'].touched">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {{formService.getErrorMessage(authForm.controls['lastName'])}}
                </div>
          </div>
        </div>
     </div>

      <div class="form-group custom-form-group"
            *ngIf="isEmailShow">
        <input type="email"
                class="form-control"
                placeholder="Email"
                name="email"
                [class.ipm-error-border]="authForm.controls['email'].invalid && authForm.controls['email'].touched"
                autocomplete="off"
                formControlName="email"

                required>
                <div class="ipm-error-icon" *ngIf="authForm.controls['email'].invalid && authForm.controls['email'].touched">
                    <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                </div>
            <div class="help-block error-message"
            *ngIf="authForm.controls['email'].invalid && authForm.controls['email'].touched">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                {{formService.getErrorMessage(authForm.controls['email'])}}
            </div>
    </div>

    <div *ngIf="isShowCurrentPassword">
        <div class="form-group custom-form-group ipm-icon-more"  >
            <input [type]="formService.textCurrentTypeField === false? 'password' : 'text'"
                    class="form-control"
                    [class.ipm-error-border]="authForm.controls['currentPassword'].invalid && authForm.controls['currentPassword'].touched"
                    placeholder="Current Password"
                    formControlName="currentPassword"
                    name="currentPassword"

                    autocomplete="off"
                    required
                    #currentPassword>
                    <div class="ipm-error-icon" *ngIf="authForm.controls['currentPassword'].invalid && authForm.controls['currentPassword'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                    <div class="eye-icon" (click)="formService.showHidePassword('currentPassword')">
                    <i class="lar"
                        [class.la-eye]="formService.textCurrentTypeField === true"
                        [class.la-eye-slash]="formService.textCurrentTypeField === false"
                        #eyeIcon ></i>
                    </div>
                <div class="help-block error-message"
                    *ngIf="authForm.controls['currentPassword'].invalid && authForm.controls['currentPassword'].touched ">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true">
                    </i>
                    {{formService.getErrorMessage(authForm.controls['currentPassword'], 'password', 8)}}
                </div>
        </div>
    </div>
    <div *ngIf="isShowPassword">
        <div class="form-group custom-form-group ipm-icon-more"  >
            <input [type]="formService.textTypeField === false? 'password' : 'text'"
                    class="form-control"
                    [class.ipm-error-border]="authForm.controls['password'].invalid && authForm.controls['password'].touched"
                    placeholder="Password"
                    formControlName="password"

                    name="password"
                    autocomplete="off"
                    required
                    #password>
                    <div class="ipm-error-icon" *ngIf="authForm.controls['password'].invalid && authForm.controls['password'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                    <div class="eye-icon" (click)="formService.showHidePassword()">
                    <i class="lar"
                        [class.la-eye]="formService.textTypeField === true"
                        [class.la-eye-slash]="formService.textTypeField === false"
                        #eyeIcon ></i>
                    </div>
                <div class="help-block error-message"
                    *ngIf="authForm.controls['password'].invalid && authForm.controls['password'].touched ">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true">
                    </i>
                    {{formService.getErrorMessage(authForm.controls['password'], 'password', 8)}}
                </div>
        </div>
    </div>
    <div  *ngIf="isConfirmPasswordShow" >
        <div class="form-group custom-form-group ipm-icon-more" >
            <input [type]="formService.textConfirmTypeField === false? 'password' : 'text'"
                    class="form-control"
                    placeholder="Confirm Password"

                    [class.ipm-error-border]="authForm.controls['confirmPassword'].invalid && authForm.controls['confirmPassword'].touched"
                    formControlName='confirmPassword'
                    autocomplete="off"
                    name="confirm-password"
                    required>
                    <div class="ipm-error-icon" *ngIf="authForm.controls['confirmPassword'].invalid && authForm.controls['confirmPassword'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                    <div class="eye-icon" (click)="formService.showHidePassword('CP')">
                    <i class="lar"
                        [class.la-eye]="formService.textConfirmTypeField === true"
                        [class.la-eye-slash]="formService.textConfirmTypeField === false"
                        #eyeIcon >
                    </i>
                    </div>
                <div class="help-block error-message"
                    *ngIf="authForm.controls['confirmPassword'].invalid && authForm.controls['confirmPassword'].touched">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {{formService.getErrorMessage(authForm.controls['confirmPassword'], 'password', 8)}}
                </div>
        </div>
    </div>
    <div class="checkout-flow mb-0"
        [class.error-show]="authForm.controls['isAcceptTermCondition'] && authForm.controls['isAcceptTermCondition'].invalid && authForm.controls['isAcceptTermCondition'].touched"
        *ngIf="isAcceptCondition">
            <mat-checkbox
                formControlName="isAcceptTermCondition"
                required>
                I hereby state that I have read and agree to the <a class="click-anchor-tag ipm-show-underline" (click)="$event.stopPropagation()" [routerLink]="['/terms-conditions']" target="_blank"> Terms and Conditions</a> and <a class="click-anchor-tag ipm-show-underline" (click)="$event.stopPropagation()" [routerLink]="['/privacy-policy']" target="_blank">Privacy Policy.</a>
            </mat-checkbox>
            <div class="help-block error-message my-1"
                *ngIf="authForm.controls['isAcceptTermCondition'] && authForm.controls['isAcceptTermCondition'].invalid && authForm.controls['isAcceptTermCondition'].touched">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Please acknowledge the term of use.
            </div>
    </div>

    <ng-content select="[actions]"></ng-content>
 </form>
